import {Component, OnInit} from '@angular/core';
import {LoaderService} from '../../../../services/loader/loader.service';
import {StatisticService} from '../../../../services/statistic/statistic.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {Paginator} from '../../../../tools/pagination/paginator';
import {ClickReport} from '../../../../models/statistic/click-report';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-click-report',
  imports: [NgForOf, NgIf, PaginatorComponent, RouterLink, DatePipe],
  templateUrl: './click-report.component.html',
  styleUrl: './click-report.component.scss'
})
@MetaTitle('Click report')
export class ClickReportComponent implements OnInit {

  private filters: any;

  statistics: ClickReport[] = [];
  paginator: Paginator = new Paginator();

  constructor(
    protected loader: LoaderService,
    private statisticService: StatisticService
  ) {
  }

  ngOnInit(): void {
    this.statistics = [];

    this.statisticService.$filters.subscribe((filters: any) => {
      this.filters = filters;
      this.fetchConversions();
    });
  }

  fetchConversions(): void {
    this.loader.startLoading();
    this.statisticService.fetchClickReport(this.filters, this.paginator).subscribe((statistics: ClickReport[]) => {
      this.statistics = statistics;
      this.loader.stopLoading();
    });
  }

}
